export const typography = {
    fontFamily: 'Roboto',
    h1: {
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: 600,
    },
    h2: {
        fontSize: '24px',
        lineHeight: '28px',
        fontWeight: 500,
    },
    h3: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 500,
    },
    h4: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 500,
    },
    body1: {
        fontSize: '16px',
        lineHeight: '24px',
    },
    body2: {
        fontSize: '24px',
        lineHeight: '32px',
    },
    subtitle1: {
        fontSize: '14px',
        lineHeight: '20px',
    },
    button: {
        fontSize: '16px',
        lineHeight: '26px',
        letterSpacing: '0.46px',
        fontWeight: 500,
    },
};
